import * as _4 from 'lodash4';
import { IDefineCommand } from 'core-ts-types';
import { AuthenticationConfiguration } from '../configuration/authentication_configuration';
import { AccountModel } from '../models/account_model';
import { URLQueryModel } from '../queries/url_query_model';
import { AccountIdentityDatastore } from '../datastore/account_identity_datastore';
import { MemberConfigurationDatastore } from '../datastore/member_configuration_datastore';
import { AuthTypeEnum } from '../types/auth_type_enum';

angular
  .module('data-ng-authentication')
  .factory(
    'logoutCommand',
    (
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      ngURLQueryModel: URLQueryModel,
      accountModel: AccountModel,
      ngAccountIdentityDatastore: AccountIdentityDatastore,
      authenticationConfiguration: AuthenticationConfiguration,
      ngMemberConfigurationDatastore: MemberConfigurationDatastore,
      resetAccountCommand: any
    ) =>
      defineCommand('logoutCommand', (deferred: any, isMobile = false) => {
        const httpMethod = ngURLQueryModel.getLogoutRequestMethod();
        const httpUrl = ngURLQueryModel.getLogoutUrl();
        let responseVar: ng.IHttpPromiseCallbackArg<any>;
        const isAuthTypeCentralAuth = AuthTypeEnum.isEqual(
          ngMemberConfigurationDatastore.store.auth_type,
          AuthTypeEnum.get('central')
        );
        const isAuthTypeSaml = AuthTypeEnum.isEqual(
          ngMemberConfigurationDatastore.store.auth_type,
          AuthTypeEnum.get('saml2_v2')
        );
        const sgdRedirectUrl = localStorage.getItem('sgdRedirectUrl');

        if (sgdRedirectUrl) {
          localStorage.removeItem('sgdRedirectUrl');
        }

        const isSSOLogout = (response: ng.IHttpPromiseCallbackArg<any>) => {
          return (
            (_4.includes(httpUrl, '/cas/') || _4.includes(httpUrl, '/saml2/')) &&
            responseVar.data &&
            responseVar.data.url
          );
        };

        const goToURL = (url: string) => {
          if (isMobile) {
            window.open(
              url,
              '_blank',
              'hardwareback=yes,toolbarposition=top,clearcache=yes,clearsessioncache=yes,enableViewportScale=yes'
            );
          } else {
            location.assign(url);
          }
        };

        const handleSSOLogout = (response: ng.IHttpPromiseCallbackArg<any>) => {
          if (isSSOLogout(response)) {
            setTimeout(() => {
              goToURL(response.data.url);
            }, 300);
          }
        };

        if (isAuthTypeCentralAuth || isAuthTypeSaml) {
          goToURL(ngMemberConfigurationDatastore.store.logout_url);
          deferred.resolve();
          return;
        }

        $http[httpMethod](httpUrl)
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            responseVar = response;
          })
          .catch((response: ng.IHttpPromiseCallbackArg<any>) => {
            return deferred.reject({
              reason: response.data.detail
            });
          })
          .finally(() => {
            if (responseVar && isSSOLogout(responseVar)) {
              handleSSOLogout(responseVar);
            } else {
              resetAccountCommand();
              ngURLQueryModel.transitionToLogoutState();
            }
            accountModel.clear();
            ngAccountIdentityDatastore.clear();
            deferred.resolve({
              logoutUrl: authenticationConfiguration.read().goToStateOnLogout
            });
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/logout_command.ts